module.exports = __webpack_public_path__ + "img/game14.bf03c5ee.png";